import { Param } from '../../../../shared/types/param';
import { ISelect, ParamEnum } from '../../../../shared/types/shared';
import { formatParams } from '../../../../shared/utils/params';
import { asyncGetParams } from '../../../../services/param.service';

const isOrbitAddressType = (param: ISelect): boolean => {
    const className = String((param as Param).class || '');
    const code = String(param.code || '');

    return (
        className === ParamEnum.ORBIT_ADDRESS_TYPE ||
        code === ParamEnum.ORBIT_ADDRESS_TYPE ||
        code.startsWith(`${ParamEnum.ORBIT_ADDRESS_TYPE}_`)
    );
};

export const asyncGetOrbitAddressTypes = async (): Promise<ISelect[]> => {
    const params = await asyncGetParams(
        ParamEnum.ORBIT_ADDRESS_TYPE,
        undefined,
        undefined,
        undefined,
        undefined,
        true
    );

    return formatParams(params.filter(isOrbitAddressType));
};
